import ipContactPanel from './contact-panel'
import ipSearchCondition from './search-condition'
import ipDataRange from './data-range'
import ipLogicSearch from './logic-search'
import ipIpcSearchModel from './ipc-model'
import ipTree from './ip-tree'
import ipCompanyCodeModel from './company-code-model'
import ipSimpleSearchCondition from './simple-search-condition'
import ipKeywordChoice from './keyword-choice'
import ipDatePicker from './date-picker'
import ipKeywordsSearchModel from './keywords-search'
import directives from "../directives/directives.js"
import ipPatentResultFilter from "./patent-result-filter"
import ipDataChoose from './data-choose'
import ipSearchModel from './search-model'
import ipPatentInfoPanel from './patent-info-pannel'
import ipAnalysisOneDimension from "./analysis-1d"
import ipAnalysisTwoDimension from "./analysis-2d"
import ipSearchOveriew from './search-overview'
import ipLanguageSwitch from './language-switch'

const components = [
    ipContactPanel,
    ipSearchCondition,
    ipDataRange,
    ipLogicSearch,
    ipIpcSearchModel,
    ipTree,
    ipCompanyCodeModel,
    ipSimpleSearchCondition,
    ipKeywordChoice,
    ipDatePicker,
    ipKeywordsSearchModel,
    ipPatentResultFilter,
    ipDataChoose,
    ipSearchModel,
    ipPatentInfoPanel,
    ipAnalysisOneDimension,
    ipSearchOveriew,
    ipAnalysisTwoDimension,
    ipLanguageSwitch
]

const install = function (Vue) {
    if (install.installed) return
    Vue.use(directives);
    components.map(component => Vue.component(component.name, component))
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default {
    install,
    ipContactPanel,
    ipSearchCondition,
    ipDataRange,
    ipLogicSearch,
    ipIpcSearchModel,
    ipTree,
    ipCompanyCodeModel,
    ipSimpleSearchCondition,
    ipKeywordChoice,
    ipDatePicker,
    ipKeywordsSearchModel,
    ipPatentResultFilter,
    ipDataChoose,
    ipSearchModel,
    ipPatentInfoPanel,
    ipAnalysisOneDimension,
    ipSearchOveriew,
    ipAnalysisTwoDimension,
    ipLanguageSwitch
}